import { makeStyles, Paper } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "components/common/TabPanel";
import withLayout from "components/HoC/withLayout";
import InformationTab from "components/home/InformationTab";
import PersonalReference from "components/home/PersonalReference";
import SmartServiceTab from "components/home/SmartServiceTab";
import WorkPermitServiceTab from "components/home/WorkPermitServiceTab";
import StepContainer from "components/request-document/StepContainer";
// import MyAgency from "components/home/MyAgency";
import DigitalWorkpermitEditorTab from "components/home/DigitalWorkpermitEditorTab";
import LtrServiceTab from "components/home/LtrServiceTab";
import { HOME_TAB } from "libs/constant/Step";
import useAuth from "libs/hooks/useAuth";
import { get } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { selectDigitalWorkpermitList } from "redux/modules/digitalWorkpermitListSlice";
import {
  getPersonalDetail,
  selectPersonalDetail
} from "redux/modules/personalSlice";
import {
  clearSmartFormStep,
  selectHomeTab,
  selectIsExtension,
  setHomeTab,
  setIsExtension
} from "redux/modules/uiSlice";
import { currentDocumentSlice, selectCheckWorkPermit } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 10px",
  },
  label: {
    alignItems: "flex-start",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
}));

function HomePage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const homeTab = useSelector(selectHomeTab);
  const personalDetail = useSelector(selectPersonalDetail);
  const isExtension = useSelector(selectIsExtension);
  const checkWorkPermitState = useSelector(selectCheckWorkPermit)
  const digitalWorkpermitList = useSelector(selectDigitalWorkpermitList)
  const { TypeOfUser } = useAuth();

  const personalId = get(personalDetail, "personalID", "");

  const handleChange = (event, newValue) => {
    dispatch(setHomeTab(newValue));
    dispatch(currentDocumentSlice.actions.clearAsyncState());
    dispatch(clearSmartFormStep());

    if (isExtension) {
      dispatch(setIsExtension(false));
    }

    if (personalId) {
      dispatch(getPersonalDetail({ personalId })); // TODO wait for refactor
    }
  };

  const hasWorkpermitHistory = digitalWorkpermitList.isSuccess && digitalWorkpermitList?.list?.length > 0

  return (
    <>
      <Tabs
        value={homeTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
      >
        <Tab label="INFORMATION" value={HOME_TAB.INFORMATION} />
        {TypeOfUser === "4f5f99be-987c-6406-8206-e44a91c6572c" ? (
          <Tab label="SMART VISA SERVICES" value={HOME_TAB.SMART_VISA_SERVICE} />
        ) : null}
        {TypeOfUser === "LTR" ? <Tab label="LTR" value={HOME_TAB.LTR_SERVICE} /> : null}

        {checkWorkPermitState.isSuccess && <Tab label="WORK PERMIT" value={HOME_TAB.WORK_PERMIT} />}
        {hasWorkpermitHistory && <Tab label="Digital Workpermit Editor" value={HOME_TAB.DIGITAL_WORKPERMIT_EDITOR} />}
        <Tab label="CHECK STATUS" value={HOME_TAB.CHECK_STATUS} />
        <Tab label="PERSONAL DEPENDENT" value={HOME_TAB.PERSONAL_REFERENCE} />
        {/* <Tab label="MY AGENCY" /> */}
        {/* <Tab label="Appointment" /> */}
        {/* <Tab label="CONTACT US" /> */}
      </Tabs>
      <TabPanel value={homeTab} index={HOME_TAB.INFORMATION}>
        <InformationTab />
      </TabPanel>

      <TabPanel
        value={homeTab}
        index={HOME_TAB.SMART_VISA_SERVICE}
      >
        <SmartServiceTab />
      </TabPanel>

      <TabPanel
        value={homeTab}
        index={HOME_TAB.LTR_SERVICE}
      >
        <LtrServiceTab />
      </TabPanel>
      <TabPanel
        value={homeTab}
        index={HOME_TAB.CHECK_STATUS}
      >
        <Paper className={classes.paper}>
          <StepContainer />
        </Paper>
      </TabPanel>
      <TabPanel
        value={homeTab}
        index={HOME_TAB.PERSONAL_REFERENCE}
      >
        <Paper className={classes.paper}>
          <PersonalReference />
        </Paper>
      </TabPanel>
      <TabPanel
        value={homeTab}
        index={HOME_TAB.WORK_PERMIT}
      >
        <Paper className={classes.paper}>
          <WorkPermitServiceTab />
        </Paper>
      </TabPanel>
      <TabPanel
        value={homeTab}
        index={HOME_TAB.DIGITAL_WORKPERMIT_EDITOR}
      >
        <Paper className={classes.paper}>
          <DigitalWorkpermitEditorTab />
        </Paper>
      </TabPanel>
      {/* <TabPanel
        value={homeTab}
        index={
          TypeOfUser === "LTR" ? HOME_TAB.MY_AGENCY - 1 : HOME_TAB.MY_AGENCY - 1
        }
      >
        <Paper className={classes.paper}>
          <MyAgency />
        </Paper>
      </TabPanel> */}
      {/* <TabPanel value={homeTab} index={HOME_TAB.APPOINTMENT}>
        <Paper className={classes.paper}>
          <AppointmentTab />
        </Paper>
      </TabPanel> */}
      {/* <TabPanel value={homeTab} index={HOME_TAB.CONTACT_US}>
        Item 4
      </TabPanel> */}
    </>
  );
}

export default withLayout(HomePage);
